import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { debounce } from 'lodash';
import { FORMS_TYPES } from 'common/types';
import CustomTextField from 'components/CustomTextField';
import { useFormValidation } from 'services/hooks/useFormValidation';
import { CONSTRAINTS, DEBOUNCE_DELAY, LIMITED_USER_ACCESS_EDIT_ALLOWED } from './constants';
import { FormValueProFormaCapTable, ProformaCapTableFormProps } from './ProformaCapTableForm.props';

const ProformaCapTableForm = ({ initialValues, onFormChange, tableTerms }: ProformaCapTableFormProps) => {
  const { formValidated, validateForm } = useFormValidation(CONSTRAINTS);
  const [formValues, setFormValues] = useState<FormValueProFormaCapTable>(initialValues);
  const { errors } = formValidated;

  useEffect(() => {
    validateForm(formValues);
  }, [validateForm, formValues]);

  const onInputChange = debounce(() => {
    onFormChange(formValidated);
  }, DEBOUNCE_DELAY);

  useEffect(() => {
    onInputChange();
  }, [onInputChange, onFormChange, formValidated]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleCheckboxChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: checked,
    }));
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <CustomTextField
          required
          fullWidth
          id="name"
          name="name"
          type="text"
          label={`${tableTerms.tableName} name`}
          value={(formValues.name as string) ?? ''}
          onChange={handleChange}
          formErrors={errors as FORMS_TYPES.FormFieldErrors}
        />
      </Grid>
      <Grid size={12}>
        <FormControlLabel
          control={
            <Checkbox
              name="limited_user_access_edit_allowed"
              checked={(formValues.limited_user_access_edit_allowed as boolean) ?? false}
              onChange={handleCheckboxChange}
            />
          }
          label={
            <Typography sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
              {LIMITED_USER_ACCESS_EDIT_ALLOWED}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
};

export default ProformaCapTableForm;
